import { render, staticRenderFns } from "./projects.vue?vue&type=template&id=4e670e1b&scoped=true&"
import script from "./projects.vue?vue&type=script&lang=ts&"
export * from "./projects.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e670e1b",
  null
  
)

export default component.exports